import { api } from '@/api';
import type {
  ExchangeOffersRequestPassengerSpecificationDTO,
  SearchOffersDTO,
} from '@/types/dto/agent';

/**
 * Finds the exchange offers for a journey-change deep-link. The link scopes the
 * change to a single booked fulfillment for one passenger; the backend validates
 * `exchangeToken` against those and returns the trips available for the new
 * origin/destination/departure — shape-compatible with the regular search results
 * so the same trip cards render.
 */
export const findExchangeOffersByToken = async ({
  booking,
  fulfillmentId,
  departureTime,
  originStopCode,
  destinationStopCode,
  currency,
  passengerSpecifications,
  exchangeToken,
}: {
  booking: string;
  fulfillmentId: string;
  departureTime: string;
  originStopCode?: string;
  destinationStopCode?: string;
  currency: string;
  passengerSpecifications: Array<ExchangeOffersRequestPassengerSpecificationDTO>;
  exchangeToken: string;
}): Promise<SearchOffersDTO> => {
  const response = await api.agentApi.Modifications_FindExchangeOffers(
    { bookingId: booking },
    {
      fulfillmentIds: [fulfillmentId],
      departureTime,
      ...(originStopCode ? { originStop: { code: originStopCode } } : {}),
      ...(destinationStopCode
        ? { destinationStop: { code: destinationStopCode } }
        : {}),
      currency,
      passengerSpecifications,
      exchangeToken,
    }
  );

  return response.data;
};
